import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import FileInfos from 'hb-react/shared/components/FilePreview/Common/Infos';
import FileReactions from 'hb-react/shared/components/FilePreview/Common/Reactions';

import Content from './Content';
import Swipper from './Swipper';

const Mobile = ({
  categories,
  file,
  user,
  hasMessagingButton = false,
  reactions,
  onSwipedLeft,
  onSwipedRight,
  isLoading,
  folderUrl,
  showReactions = true,
  postContent,
}) => (
  <Swipper onSwipedLeft={onSwipedLeft} onSwipedRight={onSwipedRight}>
    <WrapperStyled>
      <FileInfos
        file={file}
        user={user}
        hasMessagingButton={hasMessagingButton}
        folderUrl={folderUrl}
        postContent={postContent}
      />
    </WrapperStyled>
    <Content file={file} isLoading={isLoading} categories={categories} />
    {showReactions && <FileReactions file={file} reactions={reactions} />}
  </Swipper>
);

Mobile.propTypes = {
  categories: PropTypes.array,
  folderUrl: PropTypes.string,
  file: PropTypes.object,
  hasMessagingButton: PropTypes.bool,
  onSwipedLeft: PropTypes.func,
  onSwipedRight: PropTypes.func,
  reactions: PropTypes.shape({
    type: PropTypes.string.isRequired,
  }).isRequired,
  showReactions: PropTypes.bool,
  user: PropTypes.object,
};

export default Mobile;

const WrapperStyled = styled(Box).attrs({
  display: 'block',
  mb: 5,
})``;
